var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgEditIcon = function SvgEditIcon(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1517 7.84827C23.8792 7.57692 23.5556 7.36225 23.1997 7.21666C22.8438 7.07108 22.4625 6.99746 22.0779 7.00007C21.6934 7.00267 21.3131 7.08144 20.9592 7.23183C20.6052 7.38222 20.2846 7.60125 20.0158 7.87627L8.41598 19.4761L7 25L12.5239 23.5832L24.1237 11.9834C24.3988 11.7147 24.6179 11.3942 24.7684 11.0403C24.9188 10.6864 24.9976 10.3062 25.0002 9.92167C25.0028 9.53715 24.9292 9.15592 24.7835 8.80003C24.6379 8.44415 24.4232 8.12066 24.1517 7.84827V7.84827Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6846 8.20801L23.7917 12.3151",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.41699 19.4751L12.5281 23.579",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgEditIcon);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTI0LjE1MTcgNy44NDgyN0MyMy44NzkyIDcuNTc2OTIgMjMuNTU1NiA3LjM2MjI1IDIzLjE5OTcgNy4yMTY2NkMyMi44NDM4IDcuMDcxMDggMjIuNDYyNSA2Ljk5NzQ2IDIyLjA3NzkgNy4wMDAwN0MyMS42OTM0IDcuMDAyNjcgMjEuMzEzMSA3LjA4MTQ0IDIwLjk1OTIgNy4yMzE4M0MyMC42MDUyIDcuMzgyMjIgMjAuMjg0NiA3LjYwMTI1IDIwLjAxNTggNy44NzYyN0w4LjQxNTk4IDE5LjQ3NjFMNyAyNUwxMi41MjM5IDIzLjU4MzJMMjQuMTIzNyAxMS45ODM0QzI0LjM5ODggMTEuNzE0NyAyNC42MTc5IDExLjM5NDIgMjQuNzY4NCAxMS4wNDAzQzI0LjkxODggMTAuNjg2NCAyNC45OTc2IDEwLjMwNjIgMjUuMDAwMiA5LjkyMTY3QzI1LjAwMjggOS41MzcxNSAyNC45MjkyIDkuMTU1OTIgMjQuNzgzNSA4LjgwMDAzQzI0LjYzNzkgOC40NDQxNSAyNC40MjMyIDguMTIwNjYgMjQuMTUxNyA3Ljg0ODI3VjcuODQ4MjdaIiBzdHJva2U9ImJsYWNrIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTE5LjY4NDYgOC4yMDgwMUwyMy43OTE3IDEyLjMxNTEiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNOC40MTY5OSAxOS40NzUxTDEyLjUyODEgMjMuNTc5IiBzdHJva2U9ImJsYWNrIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==";